// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2aARE","label":"Completed_label__3OPgh"};